import { datadogRum } from "@datadog/browser-rum-slim"

export const logDatadogRum = (err: Error, context?: object | undefined) => {
    datadogRum.addError(err, context)
}

export const logDatadogRumMessage = (err: string, context?: object | undefined) => {
    datadogRum.addError(Error(err), context)
}

export const logDatadogRumAndThrow = (err: Error, context?: object | undefined) => {
    logDatadogRum(err, context)
    throw err
}
